import { useParams } from 'react-router-dom'
import { useGetTodosQuery } from "./todoApiSlice"
import useTitle from '../../hooks/useTitle'
import EditToDoForm from './editToDoForm'
import PulseLoader from 'react-spinners/PulseLoader'


const EditToDo = () => {

    useTitle('DPE: Edit ToDo')

    const { id } = useParams()

    const { todo } = useGetTodosQuery("todoList", {
        selectFromResult: ({ data }) => ({
            todo: data?.entities[id]
        }),
    })

	if (!todo) return <PulseLoader color={"#5f788a"} />


    const content = <EditToDoForm todo={todo} />

    return content

}

export default EditToDo